import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tracker-action" }
const _hoisted_2 = { class: "tracked" }
const _hoisted_3 = { class: "tracker-spinner" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_SmoothResize = _resolveComponent("SmoothResize")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SmoothResize, {
      active: $data.save_complete ? 'tracked' : 'add'
    }, {
      tracked: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            icon: "check",
            stroke: "var(--brand-300)",
            size: "1.4rem"
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" Tracked "))
        ])
      ]),
      add: _withCtx(() => [
        _createVNode(_component_Button, {
          primary: "",
          tiny: "",
          class: "add-tracker",
          gap: "0.4rem",
          disabled: $props.saving,
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('add')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SmoothResize, {
              class: "tracker-icon",
              active: $props.saving ? 'loader' : $props.tracked ? 'check' : 'plus'
            }, {
              loader: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_Icon, {
                    icon: "loader",
                    size: "1.4rem",
                    stroke: "var(--base-white)"
                  })
                ])
              ]),
              check: _withCtx(() => [
                _createVNode(_component_Icon, {
                  icon: "check",
                  size: "1.4rem",
                  stroke: "var(--base-white)"
                })
              ]),
              plus: _withCtx(() => [
                _createVNode(_component_Icon, {
                  icon: "plus",
                  size: "1.4rem",
                  stroke: "var(--base-white)"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["active"]),
            _cache[2] || (_cache[2] = _createTextVNode(" Add Tracker "))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["active"])
  ]))
}